import {
  failureOf,
  RestoreNoTransactionError,
  withFailure,
  readOwnerUid,
} from '@forest/paywall-core'
import isNetworkError from 'is-network-error'
import { isHTTPError, isTimeoutError } from 'ky'
import { showDialog } from '~/components/dialog'
import { platform } from '~/lib/params'
import { m } from '~/paraglide/messages'
import { showSubscriptionConflictDialog } from './subscription-conflict-dialog'

export async function showRestoreErrorDialog(error: unknown) {
  const failure = failureOf(error, 'restore')

  if (error instanceof RestoreNoTransactionError) {
    showDialog({
      title: m.dialog_restore_error_title(),
      description: withFailure(
        platform === 'china_android'
          ? m.dialog_restore_no_transaction_content_cna()
          : m.dialog_restore_no_transaction_content({
              app_store_account:
                platform === 'ios' ? m.apple_id() : m.google_play_store_id(),
            }),
        failure,
      ),
      buttonText: m.OK(),
    })
    return
  }

  if (isHTTPError(error)) {
    switch (error.response.status) {
      case 409:
      case 412:
        if (platform !== 'china_android') {
          await showSubscriptionConflictDialog(
            await readOwnerUid(error),
            failure,
          )
          return
        }
      // falls through for china_android
      case 403:
        if (platform !== 'china_android') {
          showDialog({
            title: m.dialog_restore_error_title(),
            description: withFailure(
              m.dialog_restore_error_forest_account_content({
                app_store_account:
                  platform === 'ios' ? m.apple_id() : m.google_play_store_id(),
              }),
              failure,
            ),
            buttonText: m.OK(),
          })
          return
        }
      // falls through for china_android
      case 410:
        showDialog({
          title: m.dialog_transaction_expired_title(),
          description: withFailure(
            m.dialog_transaction_expired_content(),
            failure,
          ),
          buttonText: m.OK(),
        })
        return
      default:
        showDialog({
          title: m.dialog_restore_error_title(),
          description: withFailure(
            m.dialog_unknown_error_content({ error_code: failure.code }),
            failure,
            { codeInDescription: true },
          ),
          buttonText: m.OK(),
          buttonAction: undefined,
        })
        return
    }
  }

  if (isNetworkError(error) || isTimeoutError(error)) {
    showDialog({
      title: m.dialog_no_internet_title(),
      description: withFailure(m.dialog_no_internet_content(), failure),
      buttonText: m.OK(),
    })
    return
  }

  showDialog({
    title: m.dialog_restore_error_title(),
    description: withFailure(
      m.dialog_unknown_error_content({ error_code: failure.code }),
      failure,
      { codeInDescription: true },
    ),
    buttonText: m.OK(),
    buttonAction: undefined,
  })
}
